<template>
	<Row>
		<div class="xl:container gap-[80px]">
			<Container>
				<div class="trading-homework">
					<div class="tim-section-bg">
						<slot />
					</div>
				</div>
			</Container>
		</div>
	</Row>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
:deep(#homework) {
	:deep(.have_bullets) {
		background: transparent !important;
	}
}
:deep(.tim-section-light) {
	background: #fff;
}

:deep(.trading-homework .tim-section-default) {
	padding: 0;
	padding-bottom: 52px;
}

:deep(.tim-site-header-homework .tim-menu-homework) {
	padding: 50px 0;
	margin: 0 -15px;
	display: flex;
	justify-content: center;
	flex-wrap: wrap;
	overflow: hidden;
}

@media (min-width: 768px) {
	:deep(.tim-site-header-homework .tim-menu-homework) {
		height: 275px;
		overflow: visible;
	}
}

:deep(.tim-site-header-homework .tim-menu-homework li) {
	float: left;
	padding: 0 13px;
	width: 50%;
}

:deep(.trading-homework .video) {
	max-width: 100%;
	padding: 25px 0 50%;
	position: relative;
}

:deep(.trading-homework .video .iframe-wrap) {
	z-index: 1;
	position: relative;
}

:deep(.trading-homework .tim-homework-content p .homework) {
	color: #3fa9f5;
}

@media (min-width: 768px) {
	:deep(.tim-site-header-homework .tim-menu-homework li) {
		width: 14.28%;
	}

	:deep(.trading-homework .video .iframe-wrap) {
		width: 640px;
	}

	:deep(.trading-homework .video) {
		padding: 5px 50px 0;
		display: inline-block;
		border-radius: 2px;
	}

	:deep(.trading-homework .video::before) {
		background: #1e3a8a;
		content: "";
		display: block;
		top: 35px;
		left: 0;
		right: 0;
		bottom: 30px;
		position: absolute;
		border-radius: 2px;
	}
}

:deep(.tim-site-header-homework .tim-menu-homework li a) {
	display: block;
	background: #f5f5f5;
	width: 100%;
	height: 154px;
	text-align: center;
	font-size: 14px;
	border-radius: 2px;
	font-family: Poppins;
	font-weight: 600;
	padding: 35px 12px 15px 12px;
	color: #292b2c;
	position: relative;
}

:deep(.tim-site-header-homework .tim-menu-homework li a::before) {
	content: "";
	display: block;
	background: #f5f5f5;
	width: 20px;
	height: 20px;
	border-radius: 50%;
	position: absolute;
	bottom: -60px;
	left: 45%;
}

:deep(.tim-site-header-homework .tim-menu-homework li a span) {
	font-size: 14px;
	display: block;
	font-weight: 400;
	line-height: 2.6;
	padding-top: 10px;
}

:deep(.tim-site-header-homework .tim-menu-homework li a:hover) {
	background: #1e3a8a;
	color: #fff;
	text-decoration: none;
}

:deep(.tim-site-header-homework .tim-menu-homework li.current-menu-item a) {
	background: #1e3a8a;
	color: #fff;
}

:deep(
		.tim-site-header-homework .tim-menu-homework li.current-menu-item a::before
	) {
	background: #fff;
	border: 5px solid #1e3a8a;
}

:deep(.tim-site-header-homework .tim-menu-homework li.tim-menu-previous a) {
	background: #abf8c5;
	color: #fff;
}

:deep(
		.tim-site-header-homework .tim-menu-homework li.tim-menu-previous a::before
	) {
	background: #abf8c5;
}

:deep(
		.tim-site-header-homework .tim-menu-homework li.tim-menu-previous a::after
	) {
	content: "";
	position: absolute;
	bottom: -53px;
	display: block;
	left: 50%;
	width: 5px;
	height: 8px;
	border: solid #fff;
	border-width: 0 2px 2px 0;
	transform: rotate(45deg);
}

:deep(.tim-footer-homework) {
	background: #1e3a8a;
	padding: 45px 0;
	color: #fff;
}

:deep(.trading-homework .tim-homework-content) {
	padding: 120px 0;
	text-align: center;
	font-family: Poppins;
}

:deep(.trading-homework .tim-homework-content p) {
	margin: 50px;
	font-size: 24px;
	font-weight: 300;
}

:deep(.trading-homework .video iframe) {
	display: block;
	box-shadow: 0 29px 60px 0 rgba(54, 57, 73, 0.09);
	width: 100%;
}

@media (min-width: 767px) {
	:deep(.trading-homework .video iframe) {
		height: 360px !important;
		width: 640px !important;
	}
}

@media (max-width: 767px) {
	:deep(.tim-site-header-homework .tim-menu-homework li a::before) {
		bottom: -24px;
	}

	:deep(.trading-homework .video iframe) {
		max-width: 100%;
		position: absolute;
		top: -62px;
		left: 0;
		width: 100%;
	}

	:deep(.tim-site-header-homework .tim-menu-homework) {
		row-gap: 40px;
	}

	:deep(.trading-homework .tim-section-default) {
		padding-bottom: 16px;
	}

	:deep(.tim-disclaimer) {
		top: 0;
		position: relative;
		margin-bottom: 24px;
	}

	:deep(.tim-disclaimer p) {
		padding-top: 32px;
	}

	:deep(#toc_container) {
		display: none;
	}
}

:deep(.tim-site-header-homework .tim-menu-homework li.tim-menu-previous a) {
	background: #abf8c5;
	color: #222;
}

:deep(.tim-disclaimer p) {
	margin: 50px;
	font-size: 24px;
	font-weight: 300;
}

:deep(.tim-disclaimer p) {
	font-size: 15px !important;
	color: #a0a3a7 !important;
	margin: 50px !important;
	font-weight: 300 !important;
	text-align: center !important;
}
</style>
